import { render } from "./bootableusb.md?vue&type=template&id=06e7e21c"
import script from "./bootableusb.md?vue&type=script&lang=js"
export * from "./bootableusb.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__